import { IAttribute } from '@gn-audio/core/api/product-catalogue/models/attribute';

// Union type is used in order to make .filter usage possible.
export const getAttributeValue = (attributes: (string | IAttribute)[] = [], attributeKey: string): string => {
  if (attributes.length === 0) {
    return '';
  }

  const attribute: string | IAttribute = attributes
    .filter((a: string | IAttribute): boolean => {
      if (typeof a === 'string') {
        return a.indexOf(`${attributeKey}|`) === 0;
      } else {
        return a.key.toLowerCase() === attributeKey;
      }
    })[0];

  return (typeof attribute === 'string' ? attribute.split('|')[1] : attribute.value);
};
